import {LpNewLeadRequest} from "@data/schema/new-lead-request";

export class InviteBorrower {
    quoteId: number;
    ppeProductId: number;
    lpNewLeadRequestDTO: LpNewLeadRequest;
    loanAppBundleId : string;

    constructor(quoteId: number, ppeProductId: number,lpNewLeadRequestDTO: LpNewLeadRequest,loanAppBundleId? : string){
        this.quoteId = quoteId;
        this.ppeProductId = ppeProductId;
        this.lpNewLeadRequestDTO = lpNewLeadRequestDTO;
        this.loanAppBundleId = loanAppBundleId;
    }
}
